import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {PackageService, PackageType, PackageTypeName} from '../_services/package.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {CounterService} from '../_services/counter.service';
import {TimeService} from '../_services/time.service';
import {IncomingdrawsService} from '../_services/incomingdraws.service';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';
import {BundlesCarouselComponent} from '../bundles/bundles-carousel/bundles-carousel.component';
import {ScratchService} from '../scratch/scratch.service';

@Component({
  selector: 'app-carousel-packages',
  templateUrl: './carousel-packages.component.html',
  styleUrls: ['./carousel-packages.component.scss']
})
export class CarouselPackagesComponent implements OnInit, OnDestroy {
  desktop: any;
  itemsArr: Observable<any>;
  itemsSize: number;
  nav: true;
  languageChange: Subscription;
  showLang: any;
  priceName: any;
  xx: any;
  changedCurrency: Subscription;
  currency: any;
  done: any;
  packageTypes: PackageType;
  @Input() packageType: PackageTypeName;
  carouselTitle: string;
  showPackageBundleDetailsPopup: boolean
  currentPackageToRenderDetails: any
  constructor(private lotteriesService: LotteriesService, public subscriptionsService: SubscriptionsService,
              public counterService: CounterService, public timeService: TimeService,
              public incomingDrawsService: IncomingdrawsService,
              public currencyService: CurrencyService,
              public jackpotConfig: JackpotConfigService,
              private scratchService: ScratchService) {
    this.done = false;

  }

  ngOnInit() {

    this.getLang();
    this.getPackages();
    this.packageTypes = PackageService.types;

    this.languageChange = this.subscriptionsService.getLanguage().subscribe( lang => {
      this.showLang = lang;
      if ( this.showLang === 'en') {
        this.priceName = 'jackpotAsStringRounded';
      } else {
        this.priceName = 'jackpotAsStringRoundedDE';
      }
    });

    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
      }
    });

    setTimeout(() => {
      this.done = true;
    }, 1500)

  }

  ngOnDestroy() {
    if (this.languageChange) {
      this.languageChange.unsubscribe();
    }
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
  }

  getRestLotteries(result) {
    this.itemsArr = result;
    this.itemsSize = result.length;
  }

  async getPackages() {
    await fetch(globals.appDomain + '/packages/getProductForCarouselByType/getBundle.html?type=' + this.packageType.param)
      .then(response => response.json())
      .then(data => {
        this.itemsArr = data;
        this.itemsSize = data.length;
      });
  }

  valueOfIndex(i, v) {
    return this.itemsArr[i][v];
  }

  counter(i: number) {
    return new Array(i);
  }

  getLang() {
    if ( localStorage.getItem('pageLanguage') === 'de'
      || localStorage.getItem('pageLanguage') === 'en'
      || localStorage.getItem('pageLanguage') === 'id'
      || localStorage.getItem('pageLanguage') === 'vi') {
      this.showLang = localStorage.getItem('pageLanguage');
    } else {
      setTimeout(() => {
        this.getLang();
      }, 200);
    }
  }

  showBundleDetailPopup(item) {
    this.showPackageBundleDetailsPopup = !this.showPackageBundleDetailsPopup;
    this.currentPackageToRenderDetails = item;
  }

  onChangePopupVisibility(e) {
    this.showPackageBundleDetailsPopup = false;
  }

}
